// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixedHeaderDesktop {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  margin-top: 10px;
}

.fixedHeaderMovil {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}

.categoria {
  font-size: medium;
  color: dimgray;
  padding: 2px 12px;
  margin: 0px;
  font-family: Roboto Condensed;
}

.familia {
  font-size: medium;
  color: chocolate;
  padding: 2px 12px;
  margin: 0px;
  font-family: Roboto Condensed;
}

.nombre {
  padding: 6px 2px;
  margin: 0px;
  font-size: large !important;
  color: dimgray;
  font-family: Roboto Condensed;
}

.datoDerecha {
  padding: 2px 2px;
  text-align: start;
  margin: 0px;
  font-size: medium !important;
  color: chocolate;
  font-family: Roboto Condensed;
  font-weight: 200;
}

.modelo {
  color: dimgray;
}

.datoIzquierda {
  padding: 2px 2px;
  text-align: end;
  margin: 0px;
  font-size: medium !important;
  color: dimgray;
  font-family: Roboto Condensed;
}

.precio {
  color: brown;
}

ion-card-content {
  padding: 6px 6px;
}

ion-badge {
  font-size: x-small;
}

ion-thumbnail {
  --border-radius: 5px;
  --size: 200px;
  margin-right: 3px;
  margin-top: 18px;
}

ion-img::part(image) {
  border-radius: 50%;
}

@media only screen and (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  .datoIzquierda {
    font-size: medium;
  }
  .nombre {
    font-size: large;
  }
  .datoDerecha {
    font-size: medium;
  }
}
@media (prefers-color-scheme: dark) {
  .nombre {
    color: #9b9a9a;
  }
  .datoIzquierda {
    color: #9b9a9a;
  }
}
.numeroFiltros {
  font-family: Roboto Condensed;
  font-size: medium;
}

.item-inner {
  padding: 0;
}

.imgArticuloMovil {
  object-fit: cover;
  aspect-ratio: 1/1;
  border: 0;
  padding: 0;
  border-radius: 50%;
}

.imgArticuloDesktop {
  object-fit: cover;
  aspect-ratio: 1/1;
  border: 0;
  padding: 0;
  border-radius: 50%;
}

.imgArticuloGrid {
  object-fit: cover;
  aspect-ratio: 1/1;
  border: 0;
  padding: 0;
  border-radius: 50%;
  max-width: 40px;
}

.customer-photo {
  display: inline-block;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-size: 37px 37px;
  background-position: center center;
  vertical-align: middle;
  line-height: 35px;
  box-shadow: inset 0 0 1px #999, inset 0 0 10px rgba(0, 0, 0, 0.2);
}

.customer-name {
  display: inline-block;
  vertical-align: middle;
  line-height: 32px;
  padding-left: 10px;
}

.red {
  color: #d9534f;
}

.text-bold {
  font-weight: 600;
}

.k-grid-header {
  position: sticky;
  top: 0;
}

.mostrados {
  font-size: small;
  color: #6c757d;
  text-align: end;
  padding-right: 10px;
  max-width: 110px;
}

.separadordiv {
  padding: 5px 0px !important;
  padding-left: 3px !important;
}

.kendo {
  margin: 0 7% !important;
  background-color: #5f656b;
  padding: 0px;
}

@media only screen and (max-width: 1920px) {
  .kendo {
    margin: 0px !important;
  }
}
.k-table-td.k-touch-action-auto {
  padding: 2px 5px !important; /* depends on theme */
}`, "",{"version":3,"sources":["webpack://./src/app/components/lista-articulos/lista-articulos.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AACJ;;AAEA;EACI,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;AACJ;;AAEA;EACI,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,cAAA;EACA,6BAAA;AACJ;;AAKA;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AAFJ;;AAOA;EACI,cAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;EACA,cAAA;EACA,6BAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,kBAAA;AAJJ;;AASA;EACI,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AANJ;;AASA;EACE,kBAAA;AANF;;AAWA;EACI;IACI,iBAAA;EARN;EAWE;IACI,gBAAA;EATN;EAYE;IACI,iBAAA;EAVN;AACF;AAcA;EACI;IACI,cAAA;EAZN;EAeE;IACI,cAAA;EAbN;AACF;AA4BA;EACI,6BAAA;EACA,iBAAA;AA1BJ;;AA6BA;EACI,UAAA;AA1BJ;;AA6BA;EACE,iBAAA;EACD,iBAAA;EACA,SAAA;EACA,UAAA;EACC,kBAAA;AA1BF;;AA4BA;EACE,iBAAA;EACA,iBAAA;EACD,SAAA;EACA,UAAA;EAEC,kBAAA;AA1BF;;AA6BA;EACE,iBAAA;EACA,iBAAA;EACD,SAAA;EACA,UAAA;EAEC,kBAAA;EACA,eAAA;AA3BF;;AA+BA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,kCAAA;EACA,sBAAA;EACA,iBAAA;EACA,iEAAA;AA5BJ;;AAgCE;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AA7BJ;;AAgCE;EACE,cAAA;AA7BJ;;AAgCE;EACE,gBAAA;AA7BJ;;AAkCE;EACE,gBAAA;EACA,MAAA;AA/BJ;;AAsCC;EACG,gBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAnCJ;;AAsCE;EACE,2BAAA;EACA,4BAAA;AAnCJ;;AAwCE;EACE,uBAAA;EACA,yBAAA;EACA,YAAA;AArCJ;;AAwCE;EACE;IACE,sBAAA;EArCJ;AACF;AAwCA;EAEE,2BAAA,EAAA,qBAAA;AAvCF","sourcesContent":[".fixedHeaderDesktop {\r\n    position: sticky;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 9999;\r\n    margin-top: 10px;\r\n}\r\n\r\n.fixedHeaderMovil{\r\n    position: sticky;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 9999;\r\n}\r\n\r\n.categoria {\r\n    font-size: medium;\r\n    color: dimgray;\r\n    padding: 2px 12px;\r\n    margin: 0px;\r\n    font-family: Roboto Condensed;\r\n}\r\n\r\n.familia {\r\n    font-size: medium;\r\n    color: chocolate;\r\n    padding: 2px 12px;\r\n    margin: 0px;\r\n    font-family: Roboto Condensed;\r\n}\r\n\r\n.nombre {\r\n    padding: 6px 2px;\r\n    margin: 0px;\r\n    font-size: large !important ;\r\n    color: dimgray;\r\n    font-family: Roboto Condensed;\r\n\r\n}\r\n\r\n\r\n\r\n.datoDerecha {\r\n    padding: 2px 2px;\r\n    text-align: start;\r\n    margin: 0px;\r\n    font-size: medium !important;\r\n    color: chocolate;\r\n    font-family: Roboto Condensed;\r\n    font-weight: 200;\r\n\r\n\r\n}\r\n\r\n.modelo {\r\n    color: dimgray;\r\n}\r\n\r\n.datoIzquierda {\r\n    padding: 2px 2px;\r\n    text-align: end;\r\n    margin: 0px;\r\n    font-size: medium !important;\r\n    color: dimgray;\r\n    font-family: Roboto Condensed;\r\n}\r\n\r\n.precio {\r\n    color: brown;\r\n}\r\n\r\nion-card-content {\r\n    padding: 6px 6px;\r\n}\r\n\r\nion-badge {\r\n    font-size: x-small;\r\n    // margin-bottom: 15px;\r\n}\r\n\r\n\r\nion-thumbnail {\r\n    --border-radius: 5px;\r\n    --size: 200px;\r\n    margin-right: 3px;\r\n    margin-top: 18px;\r\n}\r\n\r\nion-img::part(image) {\r\n  border-radius: 50%;\r\n}\r\n\r\n\r\n\r\n@media only screen and (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {\r\n    .datoIzquierda {\r\n        font-size: medium;\r\n    }\r\n\r\n    .nombre {\r\n        font-size: large;\r\n    }\r\n\r\n    .datoDerecha {\r\n        font-size: medium;\r\n    }\r\n\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n    .nombre {\r\n        color: #9b9a9a;\r\n    }\r\n\r\n    .datoIzquierda {\r\n        color: #9b9a9a;\r\n    }\r\n}\r\n\r\n// @media only screen and (min-width: 320px) and (max-width: 576px) {\r\n//     .contenedor {\r\n//         width: 100%;\r\n//         padding-left: 23px;\r\n//         flex-direction: column-reverse;\r\n//     }\r\n\r\n//     .cajas {\r\n//         width: 100%;\r\n//     }\r\n// }\r\n\r\n.numeroFiltros{\r\n    font-family: Roboto Condensed;\r\n    font-size: medium;\r\n}\r\n\r\n.item-inner {\r\n    padding: 0;\r\n}\r\n\r\n.imgArticuloMovil {\r\n  object-fit: cover;\r\n\taspect-ratio: 1 / 1;\r\n\tborder: 0;\r\n\tpadding: 0;\r\n  border-radius: 50%;\r\n}\r\n.imgArticuloDesktop {\r\n  object-fit: cover;\r\n  aspect-ratio: 1 / 1;\r\n\tborder: 0;\r\n\tpadding: 0;\r\n   // max-height: 10vh;\r\n  border-radius: 50%;\r\n}\r\n\r\n.imgArticuloGrid {\r\n  object-fit: cover;\r\n  aspect-ratio: 1 / 1;\r\n\tborder: 0;\r\n\tpadding: 0;\r\n   // max-height: 10vh;\r\n  border-radius: 50%;\r\n  max-width: 40px;\r\n}\r\n\r\n\r\n.customer-photo {\r\n    display: inline-block;\r\n    width: 35px;\r\n    height: 35px;\r\n    border-radius: 50%;\r\n    background-size: 37px 37px;\r\n    background-position: center center;\r\n    vertical-align: middle;\r\n    line-height: 35px;\r\n    box-shadow: inset 0 0 1px #999, inset 0 0 10px rgba(0, 0, 0, 0.2);\r\n    //margin-left: 5px;\r\n  }\r\n\r\n  .customer-name {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    line-height: 32px;\r\n    padding-left: 10px;\r\n  }\r\n\r\n  .red {\r\n    color: #d9534f;\r\n  }\r\n\r\n  .text-bold {\r\n    font-weight: 600;\r\n  }\r\n\r\n\r\n\r\n  .k-grid-header {\r\n    position: sticky;\r\n    top: 0;\r\n  }\r\n\r\n\r\n\r\n\r\n\r\n .mostrados {\r\n    font-size: small;\r\n    color: #6c757d;\r\n    text-align: end;\r\n    padding-right: 10px;\r\n    max-width: 110px;\r\n  }\r\n\r\n  .separadordiv{\r\n    padding: 5px 0px !important;\r\n    padding-left: 3px !important;\r\n  }\r\n\r\n\r\n\r\n  .kendo {\r\n    margin: 0 7% !important;\r\n    background-color: #5f656b;\r\n    padding: 0px;\r\n  }\r\n\r\n  @media  only screen and (max-width: 1920px) {\r\n    .kendo {\r\n      margin : 0px !important;\r\n    }\r\n  }\r\n\r\n.k-table-td.k-touch-action-auto {\r\n  //display: block !important;\r\n  padding: 2px 5px !important; /* depends on theme */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
